document.addEventListener("DOMContentLoaded", function() {
    // Select all elements with class "responsive-nav-expand"
    var navExpand = document.querySelectorAll(".responsive-nav-expand");

    // Define the back link HTML
    var backLink = `<li class="responsive-nav-item responsive-fixed-back ">
	<a class="responsive-nav-link responsive-nav-back-link" href="javascript:;">
  <svg role="presentation" focusable="false" width="7" height="10" class="icon icon-chevron-left reverse-icon" viewBox="0 0 7 10">
  <path d="M6 1 2 5l4 4" fill="none" stroke="currentColor" stroke-width="2"></path>
</svg><span class="responsive-back-menu">Back</span>
	</a>
</li>`;

    // Convert NodeList to Array and iterate over each item
    Array.prototype.forEach.call(navExpand, function(item) {
        // Insert back link HTML into each ".responsive-nav-expand-content" element
        item.querySelector(".responsive-nav-expand-content").insertAdjacentHTML("afterbegin", backLink);
        
        // Add click event listener to toggle "active" class on ".responsive-nav-link" click
        item.querySelector(".responsive-nav-link").addEventListener("click", function() {
            item.classList.add("active");
        });
        
        // Add click event listener to remove "active" class on ".responsive-nav-back-link" click
        item.querySelector(".responsive-nav-back-link").addEventListener("click", function() {
            item.classList.remove("active");
        });
    });

    // Add click event listener to hamburger menu icon
    var ham = document.getElementById("ham");
    ham.addEventListener("click", function() {
        document.body.classList.toggle("responsive-nav-is-toggled");
        
        // Add or remove class to show/hide close button
        var closeBtnOuter = document.querySelector(".responsive-close-btn-menu-outer");
        if (document.body.classList.contains("responsive-nav-is-toggled")) {
            closeBtnOuter.classList.add("responsive-close-btn-menu-show");
        } else {
            closeBtnOuter.classList.remove("responsive-close-btn-menu-show");
        }
    });

    // Add click event listener to close button
    var closeBtn = document.querySelector(".responsive-close-btn-menu");
    closeBtn.addEventListener("click", function(event) {
        document.body.classList.remove("responsive-nav-is-toggled");
         document.body.classList.add("responsive-nav-is-toggled-loader");
        this.classList.remove("responsive-close-btn-menu-show");
    });
  document.body.classList.remove("responsive-nav-is-toggled-loader");
  let originalSelect = document.getElementById('SortBy');
  let customDropdown = document.getElementById('customDropdown');
  let crossIcon = document.querySelector('.cross_icon');
  let collectionSortDropdown = document.querySelector('.collection-dropdowns__item');

  // Toggle custom dropdown visibility
  let sortDropdown = document.querySelector(".collection-dropdowns__item");
  if(sortDropdown){
  sortDropdown.addEventListener('click', function(event) {
    customDropdown.style.display = customDropdown.style.display === 'block' ? 'none' : 'block';
    this.classList.toggle("dropdown-sort-filters");
    document.body.classList.toggle("sort-options-active");
  });
}

  // Hide custom dropdown when clicking outside
  document.addEventListener('click', function(event) {
    if(collectionSortDropdown){
    if (!collectionSortDropdown.contains(event.target)) {
      customDropdown.style.display = 'none';
      document.querySelector('.collection-dropdowns__item').classList.remove("dropdown-sort-filters");
      document.body.classList.remove("sort-options-active");
    }
    }
  });
  if(crossIcon){
  crossIcon.addEventListener('click', function(event) {
    if (!crossIcon.contains(event.target)) {
      customDropdown.style.display = 'none';
      document.querySelector('.collection-dropdowns__item').classList.remove("dropdown-sort-filters");
      document.body.classList.remove("sort-options-active");
    }
  });
  }

  // Handle option selection
  if(customDropdown){
  customDropdown.addEventListener('click', function(event) {
    let target = event.target;
    if (target.tagName === 'LI') {
      let value_dropdown = target.getAttribute('data-value');
      originalSelect.value = value_dropdown;
      customDropdown.style.display = 'none';
      document.querySelector('.collection-dropdowns__item').classList.remove("dropdown-sort-filters");
      document.body.classList.remove("sort-options-active");
      // Dispatch change event on original select
      originalSelect.dispatchEvent(new Event('change'));
    }
  });
  }
});